const lpUrl = "https://energiav.vivo.com.br/";


export const navigateToLp = () => {
    window.location.href = lpUrl;
}